import CourseGridEnrolled from "../../components/course/course-grid-enrolled/CourseGridEnrolled";
import CourseService from "../../services/course/CourseService";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Navigate } from 'react-router-dom';
import type { RootState } from '../../store/store';

function CoursesEnrolledPage() {
    const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);
    const [courses, setCourses] = useState([]);

    useEffect(() => {
        CourseService.fetchEnrolled().then(setCourses);
    }, []);

    if (!isLoggedIn)
        return <Navigate to="/login" replace />;

    return (
        <>
            <CourseGridEnrolled courses={courses} />
        </>
    )
}

export default CoursesEnrolledPage;